export const getContent = store => (store.imageSlider ? store.imageSlider : {});
export const get = store => {
  return getContent(store).imageSlide;
};
export const isLoaded = store => {
  let content = getContent(store);
  return content.isLoaded != null && content.isLoaded;
};
